import { render, staticRenderFns } from "./ShopSelect.vue?vue&type=template&id=3aee6f56&scoped=true&"
import script from "./ShopSelect.vue?vue&type=script&lang=js&"
export * from "./ShopSelect.vue?vue&type=script&lang=js&"
import style0 from "./ShopSelect.vue?vue&type=style&index=0&id=3aee6f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee6f56",
  null
  
)

export default component.exports